module.exports = __webpack_public_path__ + "static/media/1000R.1f6c9af.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/pure_tone/1000R.mp3
// module id = 6eFg
// module chunks = 1